import { Component, OnInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { TITLES } from 'src/app/shared/constants';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { getFirebaseBackend } from 'src/app/authUtils';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { UserService } from 'src/app/services/user/user.service';
import { Output } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { get } from 'jquery';
import { ViewChild } from '@angular/core';
import { OnDisplayComponent } from 'src/app/shared/on-display/on-display.component';

@Component({
	selector: 'app-prospect-info',
	templateUrl: './prospect-info.component.html',
	styleUrls: ['./prospect-info.component.scss'],
})
export class ProspectInfoComponent implements OnInit {
	prospect: any;
	user: any;
	contactForm!: FormGroup;
	DetailsTab: boolean = false;
	isCallsheetView: boolean = false;
	showCalendar: 'prospects' | 'callsheet' | 'leads' = 'prospects';
	campaignId: string;
	campaignAlias: string;
	campaignName: string = '';
	isLoading = false;

	public titles = TITLES;
	primaryPhone: string;

	prospectNotes: any[] = [];

	lastClick: number;
	fromPage: string = 'home';
	dispos: any[] = [];

	dispoLogNotes: any[] = [];

	dispoTimeline: any[] = [];

	@Output() back = new EventEmitter<any>();
	currentYear = new Date().getFullYear();
	years: number[] = [];
	@ViewChild(OnDisplayComponent) onDisplayComponent: OnDisplayComponent;

	constructor(
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private campaignSrv: CampaignsService,
		private prospectsSrv: ProspectsService,
		private router: Router,
		private loaderSrv: LoaderService,
		private userSrv: UserService,
	) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.lastClick = new Date().getTime();
	}

	goToCalendar(alias: string, id: string): void {
		if (!alias || !id) {
			console.error('❌ Alias o ID están vacíos');
			return;
		}
		this.router.navigate(['/calendar', alias, id]);
	}

	ngOnInit(): void {
		const startYear = this.currentYear - 3;
		const endYear = this.currentYear + 10;

		for (let y = startYear; y <= endYear; y++) {
			this.years.push(y);
		}
		this.loaderSrv.loading$.subscribe((val) => {
			this.isLoading = val;
		});

		this.loaderSrv.show();
		this.route.queryParams.subscribe((params) => {
			this.fromPage = params['from'] || 'home';
		});

		this.contactForm = this.fb.group({
			companyName: ['', Validators.required],
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			address1: [''],
			address2: [''],
			city: [''],
			state: [''],
			zip: [''],
			primaryPhone: [''],
			altPhone: [''],
			altContact: [''],
			ein: [''],
			form5500: [''],
			additionalInfo: [''],
			notes: [''],
			employeeSize: [''],
			title: [''],
			directLine: [''],
			mobilePhone: [''],
			extension: [''],
			website: [''],
			primaryMail: [''],
			altMail: [''],
			annualRevenue: [''],
			planAssetSize: [''],
			planParticipants: [''],
			providerCarrier1: [''],
			providerCarrier2: [''],
			renewalMonth: [''],
			renewalMonth2: [''],
			renewalYear: [''],
			renewalYear2: [''],
		});
		this.DetailsTab = false;

		const navigationData = history.state?.payload;

		if (navigationData) {
			this.campaignId = this.route.snapshot.paramMap.get('campaign_id') || this.prospectsSrv.currentCampaignId || '0';

			this.campaignAlias = this.route.snapshot.paramMap.get('alias') || this.prospectsSrv.currentCampaignAlias || '0';

			this.primaryPhone = this.route.snapshot.paramMap.get('primary_phone') || this.prospectsSrv.currentPrimaryPhone || null;
			this.campaignName = navigationData.campaignName || this.prospectsSrv.currentCampaignName || '';
			this.prospectsSrv.currentCampaignName = this.campaignName;

			this.prospect = navigationData;
			this.patchFormWithProspect(navigationData);
			this.loaderSrv.hide();
			this.loadNotes(this.prospect.id);

			return;
		}

		this.route.paramMap.subscribe((params) => {
			this.campaignId = params.get('campaign_id') || '0';
			this.campaignAlias = params.get('alias') || '0';
			this.primaryPhone = params.get('primary_phone');

			this.prospectsSrv.currentCampaignId = this.campaignId;
			this.prospectsSrv.currentCampaignAlias = this.campaignAlias;
			this.prospectsSrv.currentPrimaryPhone = this.primaryPhone;
			//this.getCampaignName(this.campaignId);
			this.campaignName = this.prospectsSrv.currentCampaignName || '';
			this.loadCalendarData(this.campaignId, this.campaignAlias);
			if (this.primaryPhone) {
				this.getRandomProspect(this.primaryPhone);
			} else {
				const savedProspect = this.prospectsSrv.getCurrentProspect();
				if (savedProspect) {
					this.prospect = savedProspect;
					this.patchFormWithProspect(savedProspect);
				} else {
					this.getRandomProspect();
				}
			}
		});
	}

	loadCalendarData(id: string, alias: string) {}

	onSubmit() {
		if (this.contactForm.valid) {
			alert('Form submitted!');
		} else {
			alert('Please fill all required fields');
		}
	}

	onExit(): void {
		if (this.fromPage === 'callback') {
			this.prospectsSrv.clearCurrentProspect();
			this.router.navigate(['/callback', this.campaignId, this.campaignAlias]);
			return;
		}

		const exitRoutes: { [key: string]: any[] } = {
			dbreset: ['/db-reset'],
			search: ['/search'],
			home: ['/'],
		};

		const targetRoute = exitRoutes[this.fromPage] || ['/'];

		Swal.fire({
			title: 'Exit this campaign?',
			text: 'Are you sure you want to leave this section?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, exit',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.isConfirmed) {
				this.prospectsSrv.clearCurrentProspect();
				this.router.navigate(targetRoute);
			}
		});
	}

	onBack(): void {}

	getRandomProspect(primary_phone = null): void {
		let prospectSubscription = this.campaignSrv.getRandomProspect(this.campaignId, this.user.IdUser);
		if (primary_phone) {
			prospectSubscription = this.campaignSrv.getRandomProspect(this.campaignId, this.user.IdUser, primary_phone);
		}

		prospectSubscription.subscribe((response) => {
			if (response.success && response.body && response.body.length > 0) {
				const data = response.body[0];

				this.campaignName = data.campaign_name || this.campaignName;
				this.prospectsSrv.currentCampaignName = this.campaignName;
				this.prospectsSrv.currentCampaignName = data.campaign_name || '';
				this.prospect = data;
				this.prospectsSrv.setCurrentProspect(data);

				if (data.primary_phone) {
					this.userSrv.saveAction(`Open Prospect Info - Phone: ${data.primary_phone}`);
				}

				this.patchFormWithProspect(data);
				this.loaderSrv.hide();
				//this.LeadById(this.prospect.id);
				this.onDisplayComponent?.refreshProspect(data);
				this.getDisposByPhone(this.prospect.primary_phone);
				this.getDispoLogNotes(this.prospect.id);
				this.loadNotes(this.prospect.id);
			}
		});
	}

	private patchFormWithProspect(data: any) {
		this.contactForm.patchValue({
			companyName: data.company_name,
			firstName: data.first_name,
			lastName: data.last_name,
			address1: data.address_1,
			address2: data.address_2,
			city: data.city,
			state: data.state,
			zip: data.zip,
			primaryPhone: data.primary_phone,
			altPhone: data.alt_phone,
			altContact: data.alt_contact,
			ein: data.EIN,
			form5500: data.form_5500,
			additionalInfo: data.additional_info,
			notes: data.notes,
			employeeSize: data.employee_size,
			title: data.title || '',
			directLine: data.direct_line || '',
			mobilePhone: data.mobile_phone || '',
			extension: data.ext,
			website: data.website_url || '',
			primaryMail: data.primary_email || '',
			altMail: data.alt_email || '',
			annualRevenue: data.annual_revenue || '',
			planAssetSize: data.plan_assets || '',
			planParticipants: data.plan_participants || '',
			providerCarrier1: data.provider_1 || '',
			providerCarrier2: data.provider_2 || '',
			renewalMonth: data.renewal_month_1 || '',
			renewalMonth2: data.renewal_month_2 || '',
			renewalYear: data.renewal_year_1 || '',
			renewalYear2: data.renewal_year_2 || '',
		});
	}

	onDispo(): void {
		this.prospectsSrv.currentCampaignId = this.campaignId;
		this.prospectsSrv.currentCampaignAlias = this.campaignAlias;
		this.prospectsSrv.currentPrimaryPhone = this.primaryPhone;

		const notesValue = this.contactForm.get('notes')?.value || '';

		if (notesValue.trim().length < 3) {
			Swal.fire({
				icon: 'warning',
				title: 'Required Notes',
				text: 'Notes must be at least 3 characters.',
				confirmButtonText: 'OK',
			});
			return;
		}

		if (!this.prospect) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Prospect data is missing, please reload the page.',
				confirmButtonText: 'OK',
			});
			return;
		}
		const formValues = this.contactForm.value;

		const payload = {
			campaignName: this.campaignName,
			campaign_id: this.campaignId,
			campaignId: this.campaignId,
			prospectId: this.prospect.id,
			campaign_alias: this.campaignAlias,
			userId: this.user.IdUser || null,
			dispo: null,
			callback: null,

			// Campos Basic
			company_name: formValues.companyName || this.prospect.company_name,
			first_name: formValues.firstName || this.prospect.first_name,
			last_name: formValues.lastName || this.prospect.last_name,
			title: formValues.title || this.prospect.title,
			address_1: formValues.address1 || this.prospect.address_1,
			address_2: formValues.address2 || this.prospect.address_2,
			city: formValues.city || this.prospect.city,
			state: formValues.state || this.prospect.state,
			zip: formValues.zip || this.prospect.zip,
			ein: formValues.ein || this.prospect.EIN,
			primary_phone: formValues.primaryPhone || this.prospect.primary_phone,
			alt_phone: formValues.altPhone || this.prospect.alt_phone,
			alt_contact: formValues.altContact || this.prospect.alt_contact,
			form_5500: formValues.form5500 || this.prospect.form_5500,
			additional_info: formValues.additionalInfo || this.prospect.additional_info,
			notes: formValues.notes || this.prospect.notes,
			business_code: formValues.businessCode || this.prospect.business_code,
			business_code_description: formValues.businessCodeDescription || this.prospect.business_code_description,

			// Campos Details
			direct_line: formValues.directLine || this.prospect.direct_line,
			mobile_phone: formValues.mobilePhone || this.prospect.mobile_phone,
			extension: formValues.extension || this.prospect.ext,
			website_url: formValues.website || this.prospect.website_url,
			primary_email: formValues.primaryMail || this.prospect.primary_email,
			alt_email: formValues.altMail || this.prospect.alt_email,
			employee_size: formValues.employeeSize || this.prospect.employee_size,
			annual_revenue: formValues.annualRevenue || this.prospect.annual_revenue,
			plan_assets: formValues.planAssetSize || this.prospect.plan_assets,
			plan_participants: formValues.planParticipants || this.prospect.plan_participants,
			provider_1: formValues.providerCarrier1 || this.prospect.provider_1,
			provider_2: formValues.providerCarrier2 || this.prospect.provider_2,
			renewal_month_1: formValues.renewalMonth || this.prospect.renewal_month_1,
			renewal_year_1: formValues.renewalYear || this.prospect.renewal_year_1,
			renewal_month_2: formValues.renewalMonth2 || this.prospect.renewal_month_2,
			renewal_year_2: formValues.renewalYear2 || this.prospect.renewal_year_2,
		};
		this.prospectsSrv.setCurrentProspect(payload);
		this.router.navigate(['/choose-dispo', this.campaignId, this.campaignAlias], { state: { payload: payload } });
	}

	onPrimaryPhoneClick(): void {
		this.userSrv.saveAction('Start Call');

		const formValues = this.contactForm.value;
		this.userSrv.startCall({
			campaign: this.campaignId,
			source_view: 'prospect_info',
			primary_phone: formValues.primaryPhone || this.prospect?.primary_phone,
			first_name: formValues.firstName || this.prospect?.first_name,
			last_name: formValues.lastName || this.prospect?.last_name,
		});
	}

	onPhoneClick(phone: string): void {
		console.log('ALT CLICK', phone);
		this.userSrv.saveAction('Start Call');

		const formValues = this.contactForm.value;
		this.userSrv.startCall({
			campaign: this.campaignId,
			source_view: 'prospect_info',
			primary_phone: phone,
			first_name: formValues.firstName || this.prospect?.first_name,
			last_name: formValues.lastName || this.prospect?.last_name,
		});
	}

	loadNotes(prospectId: number): void {
		this.campaignSrv.getLastNotes(prospectId).subscribe(
			(res: any) => {
				this.prospectNotes = res.body || [];
			},
			(err: any) => {
				console.error('Error al obtener notas:', err);
			},
		);
	}

	formatPhone(phone: string): string {
		if (!phone) return '';

		const digits = phone.replace(/\D/g, '');
		if (digits.length === 10) {
			return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
		}

		return phone;
	}

	saveLastClick() {
		this.lastClick = new Date().getTime();
	}

	exitNoQuestion() {
		this.router.navigate(['/']);
		this.back.emit(true);
	}

	changeTab(tab: 'prospects' | 'callsheet' | 'leads'): void {
		this.showCalendar = tab;
	}

	mergeDisposWithNotes(): void {
		if (!this.dispos?.length) {
			this.dispoTimeline = [];
			return;
		}

		this.dispoTimeline = this.dispos.map((dispo) => {
			const noteMatch = this.dispoLogNotes.find((n) => n.date === dispo.date && n.user_login === dispo.user_login);

			return {
				...dispo,
				notes: noteMatch?.notes || dispo.notes || '',
			};
		});
	}
	getDisposByPhone(phone: string): void {
		if (!phone) return;

		this.prospectsSrv.getDisposByPhone(phone).subscribe({
			next: (res: any) => {
				this.dispos = res?.body ?? [];
				this.mergeDisposWithNotes();
			},
		});
	}
	getDispoLogNotes(prospectId: number): void {
		if (!prospectId) return;

		this.prospectsSrv.getDispoLogNotes(prospectId).subscribe({
			next: (res: any) => {
				this.dispoLogNotes = res?.body ?? [];
				this.mergeDisposWithNotes();
			},
		});
	}
	get altPhone() {
		return this.contactForm.get('altPhone')?.value;
	}

	get altPhoneDisplay(): string {
		return this.altPhone ? this.formatPhone(this.altPhone) : 'Not provided';
	}

	get prospectTime() {
		return this.contactForm.get('prospectTime')?.value;
	}

	get prospectTimeDisplay(): string {
		return this.prospectTime || 'Not provided';
	}
}
